import React from 'react';
import CategoryTemplate from 'templates/category';
import { useTranslation } from 'react-i18next';
import { useStaticQuery, graphql } from 'gatsby';

const CategoryPage = () => {
  const [t] = useTranslation();
  const image = useStaticQuery(graphql`
    query {
      strapiCategory(slug: { eq: "hundvakt" }) {
        image {
          childImageSharp {
            fluid(maxHeight: 1024, quality: 90) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
  `);
  return (
    <CategoryTemplate
      heading={t('page--dog-minding.heading')}
      subheading={t('page--dog-minding.subheading')}
      buttonLabel={t('page--dog-minding.buttonLabel')}
      content={t('page--dog-minding.content')}
      image={image.strapiCategory.image}
      ctaTitle={t('page--dog-minding.ctaTitle')}
      seoTitle={t('page--dog-minding.seoTitle')}
      seoDescription={t('page--dog-minding.seoDescription')}
    />
  );
};
export default CategoryPage;
